export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4001';
export const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';
export const CAS_SERVER_URL =
  process.env.REACT_APP_CAS_SERVER_URL ||
  'https://fed-lab.aaiedu.hr:443/sso/module.php/casserver';
